import React from 'react';

import { SVGComponentProps } from './svg.types';

const CRMContactSVG = ({
  stroke = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherSvgProps
}: SVGComponentProps) => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...otherSvgProps}
      >
        <path
          d="M11.3334 12C11.3334 11.6463 11.1929 11.3072 10.9428 11.0572C10.6928 10.8071 10.3536 10.6666 10 10.6666H6.00002C5.6464 10.6666 5.30726 10.8071 5.05721 11.0572C4.80716 11.3072 4.66669 11.6463 4.66669 12"
          stroke={stroke}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.6667 2.66663H3.33333C2.59695 2.66663 2 3.26358 2 3.99996V13.3333C2 14.0697 2.59695 14.6666 3.33333 14.6666H12.6667C13.403 14.6666 14 14.0697 14 13.3333V3.99996C14 3.26358 13.403 2.66663 12.6667 2.66663Z"
          stroke={stroke}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.00002 8.00004C8.7364 8.00004 9.33335 7.40309 9.33335 6.66671C9.33335 5.93033 8.7364 5.33337 8.00002 5.33337C7.26364 5.33337 6.66669 5.93033 6.66669 6.66671C6.66669 7.40309 7.26364 8.00004 8.00002 8.00004Z"
          stroke={stroke}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.33331 1.33337V2.66671"
          stroke={stroke}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.6667 1.33337V2.66671"
          stroke={stroke}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
};

export default CRMContactSVG;
